import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import DialOut from './pages/DialOut';
import CallLogs from './pages/CallLogs';
import CallDetail from './pages/CallDetail';
import BulkUpload from './pages/BulkUpload';
import './App.css';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm">
          <div className="container-fluid">
            <NavLink className="navbar-brand d-flex align-items-center fw-bold" to="/">
              <i className="bi bi-shield-check me-2 fs-4"></i>
              Fintech KYC Flow
            </NavLink>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/">
                    <i className="bi bi-speedometer2 me-1"></i> Dashboard
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/dial">
                    <i className="bi bi-telephone-outbound me-1"></i> Dial Out
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/bulk-upload">
                    <i className="bi bi-upload me-1"></i> Bulk Upload
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/logs">
                    <i className="bi bi-journal-text me-1"></i> Call Logs
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <main className="flex-grow-1 bg-light">
          <div className="container-fluid py-4">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dial" element={<DialOut />} />
              <Route path="/bulk-upload" element={<BulkUpload />} />
              <Route path="/logs" element={<CallLogs />} />
              <Route path="/calls/:id" element={<CallDetail />} />
            </Routes>
          </div>
        </main>

        <footer className="bg-dark text-light text-center py-2 small">
          Fintech KYC Flow
        </footer>
      </div>
    </Router>
  );
}

export default App;
